import { SWRConfiguration } from 'swr'
import { RequestInit } from '@vercel/fetch'
import { useQuery } from '@pylot-data/hooks/use-query'
import { seoBlogPageQuery } from '@pylot-data/hooks/blog/graphql/blogQuery'
import { GraphQLError } from '@pylot-data/graphqlFetch'
import { SeoBlogLandingDetailsResult } from '@pylot-data/api/operations/get-blog-landing-seo-details'

export type BlogPageResponse = {
    blogPage?: SeoBlogLandingDetailsResult
    isValidating: boolean
    error?: GraphQLError
}

export const useBlogPageSeo = (
    swrOptions?: SWRConfiguration,
    fetchOptions?: RequestInit
): BlogPageResponse => {
    const { data, error, isValidating } = useQuery<
        undefined,
        { blogPage: SeoBlogLandingDetailsResult }
    >(seoBlogPageQuery, undefined, swrOptions, fetchOptions)

    return {
        blogPage: data?.data?.blogPage,
        isValidating,
        error
    }
}
